import React from 'react'
import './player-record-item.styles.scss';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { properCase } from '@/utils/properCase';

const PlayerRecordItem = ({
  record,
  gameElements,
  viewTransaction
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const elementData = (record.elementId && gameElements)
    ? gameElements[record.elementId]
    : null;
  const rewardCount = (record.data) ? Object.values(record.data).length : 0;
  const notes = (record.comments)
    ? `"${record.comments}"`
    : (record.info)
      ? record.info
      : null;

  return (
    <div className={`player-record-item g-list-item ${screenSize}`}>
      <div className='record-title'>
        <ImageContainer
          src={record.icon ? record.icon : elementData ? elementData.icon : '/images/unknown.png'}
          alt='record icon'
          className='record-icon' />
        <div className='record-name'>
          <b>{
            record.title
              ? record.title
              : elementData
                ? elementData.name
                : record.event
          }</b>
          <div className='meta'>
            {record.event}
            {
              (record.spec) &&
              <span className={record.spec}> ({properCase(record.spec)})</span>
            }
          </div>
        </div>
      </div>
      <div className='record-notes meta'>
        {
          (notes) &&
          <div className='notes-text'>{notes}</div>
        }
        {
          (rewardCount > 0) &&
          <div>{rewardCount} Reward{rewardCount === 1 ? '' : 's'}</div>
        }
      </div>
      <div className='record-date meta'>
        {format(new Date(record.ts), 'Pp')}
      </div>
      <div className='buttons'>
        <button
          className='g-button med-btn'
          title='View transaction details'
          onClick={() => viewTransaction(record)} >
          <FontAwesomeIcon icon={faMagnifyingGlass} />
        </button>
      </div>
    </div>
  )
}

export default PlayerRecordItem
